import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  background: ${props => props.theme.colors.background};
  border-top: 230px solid ${props => props.theme.colors.primary};
`;

export const Content = styled.div`
  background: ${props => props.theme.colors.contentBackground};
  width: 100%;
  max-width: 115rem;
  margin: 0 auto;
  height: calc(100% - 4rem);
  position: fixed;
  left: 50%;
  top: 2rem;
  transform: translateX(-50%);
  box-shadow: 0px 4px 24px rgb(0 0 0 / 10%);
  display: grid;
  grid-template-columns: minmax(230px, 1fr) 5fr;

  @media only screen and (max-width: 1366px) {
    max-width: 90rem;
  }
`;

export const PageSidebar = styled.aside`
  display: flex;
  flex-direction: column;
  padding: 1.25rem;
  gap: 1.25rem;
  border-right: 1px solid ${props => props.theme.colors.border};
  overflow-y: auto;
`;

export const ContentTable = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  background: ${props => props.theme.colors.background};
`;

export const TabBar = styled.div`
  display: flex;
  border-bottom: 1px solid ${props => props.theme.colors.borderLight};
  background: ${props => props.theme.colors.contentBackground};
  flex-shrink: 0;
`;

export const Tab = styled.button<{ active: boolean }>`
  padding: 1rem 1.5rem;
  background: transparent;
  border: none;
  font-size: 0.9375rem;
  cursor: pointer;
  color: ${props => props.active ? props.theme.colors.primary : props.theme.colors.muted};
  border-bottom: 2px solid ${props => props.active ? props.theme.colors.primary : 'transparent'};
  font-weight: ${props => props.active ? 600 : 400};
  transition: all 0.15s ease;

  &:hover {
    color: ${props => props.theme.colors.primary};
  }
`;

export const SectionTitle = styled.h3`
  font-size: 0.8rem;
  text-transform: uppercase;
  color: ${props => props.theme.colors.muted};
  font-weight: 600;
  margin-bottom: 0.5rem;
  letter-spacing: 0.05em;
`;

export const SidebarActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: auto;
`;
